import React from 'react';

const PendingStripe = () => (
  <div aria-hidden className="tw-absolute tw-inset-y-0 tw-left-0 tw-w-1 tw-bg-tci-purple" />
);

export default PendingStripe;
